import { useReducer } from 'react'
import { useIntl } from 'react-intl'
import effects from 'app/effects/effects'
import MessageAlert from 'app/components/MessageAlert'
import { useDispatch } from 'react-redux'

export const ActionType = {
  SET_TRANSLATION_LANGUAGE: 'SET_TRANSLATION_LANGUAGE',
  SET_LOADER: 'SET_LOADER',
}

const initialState = {
  translationLanguage: [],
  isLoading: false,
}

const reducer = (state, action) => {
  switch (action.type) {
    case ActionType.SET_TRANSLATION_LANGUAGE:
      return {
        ...state,
        translationLanguage: action.value,
        isLoading: false,
      }

    case ActionType.SET_LOADER:
      return {
        ...state,
        isLoading: action.value,
      }
    default:
      return state
  }
}

export default function useViewInAction(id) {
  const [state, dispatch] = useReducer(reducer, initialState)
  const { formatMessage } = useIntl()
  const commonDispatch = useDispatch()

  const fetchTranslationLanguage = () => {
    dispatch({ type: 'SET_LOADER', value: true })
    effects.apis
      .getTranslationLanguageById({ notificationId: id })
      .then((response) => {
        dispatch({ type: 'SET_TRANSLATION_LANGUAGE', value: response })
      })
      .catch(() =>
        commonDispatch(
          MessageAlert.showError({
            message: formatMessage({
              id: 'error.general',
            }),
          }),
        ),
      )
  }

  return {
    state,
    fetchTranslationLanguage,
  }
}
